export default __webpack_public_path__ + "static/media/environment1.74077a0f.png";